import { render, staticRenderFns } from "./EditResource.vue?vue&type=template&id=e79d4da8&scoped=true"
import script from "./EditResource.vue?vue&type=script&lang=js"
export * from "./EditResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79d4da8",
  null
  
)

export default component.exports